import { z } from "zod";
/**
 * Safe Inbox presentation for WhatsApp inbound types that are not first-class
 * MessageType values. Never dump raw webhook JSON onto the wire.
 */
export const WHATSAPP_UNSUPPORTED_KINDS = [
    "poll_creation",
    "poll_update",
    "gif",
    "order",
    "unknown",
];
export const UNSUPPORTED_PRESENTATION_SCOPES = ["whatsapp", "instagram", "generic"];
export const INSTAGRAM_UNSUPPORTED_KINDS = ["sticker", "location", "content"];
export const WHATSAPP_INTERACTIVE_KINDS = [
    "button_reply",
    "list_reply",
    "nfm_reply",
    "product",
    "unknown",
];
export const messageContactPresentationDtoSchema = z.object({
    formattedName: z.string().min(1).optional(),
    firstName: z.string().min(1).optional(),
    lastName: z.string().min(1).optional(),
    primaryPhone: z.string().min(1).optional(),
    additionalPhoneCount: z.number().int().nonnegative().optional(),
    primaryEmail: z.string().min(1).optional(),
    organization: z.string().min(1).optional(),
});
export const messageLocationPresentationDtoSchema = z.object({
    latitude: z.number().gte(-90).lte(90),
    longitude: z.number().gte(-180).lte(180),
    name: z.string().min(1).optional(),
    address: z.string().min(1).optional(),
});
export const messageUnsupportedPresentationDtoSchema = z.object({
    kind: z.enum(WHATSAPP_UNSUPPORTED_KINDS),
    scope: z.enum(UNSUPPORTED_PRESENTATION_SCOPES).optional(),
    instagramKind: z.enum(INSTAGRAM_UNSUPPORTED_KINDS).optional(),
});
export const messageInteractivePresentationDtoSchema = z.object({
    kind: z.enum(WHATSAPP_INTERACTIVE_KINDS),
});
/** Instagram/Meta shared post, reel, story, or other link-share cards. */
export const messageSharePresentationDtoSchema = z.object({
    shareType: z.string().min(1),
    title: z.string().min(1).optional(),
    captionSnippet: z.string().min(1).optional(),
    username: z.string().min(1).optional(),
    previewAttachment: z
        .object({
        attachmentId: z.string().min(1),
        attachmentType: z.string().min(1),
        mimeType: z.string().nullable().optional(),
        storageState: z
            .enum(["METADATA_ONLY", "PENDING_STORAGE", "STORED", "UNAVAILABLE", "EXPIRED"])
            .optional(),
    })
        .optional(),
});
/** Story reply context on an Instagram inbound text message. */
export const messageStoryReplyPresentationDtoSchema = z.object({
    storyId: z.string().min(1).optional(),
    previewAttachment: z
        .object({
        attachmentId: z.string().min(1),
        attachmentType: z.string().min(1),
        mimeType: z.string().nullable().optional(),
        storageState: z
            .enum(["METADATA_ONLY", "PENDING_STORAGE", "STORED", "UNAVAILABLE", "EXPIRED"])
            .optional(),
    })
        .optional(),
    unavailable: z.boolean().optional(),
});
//# sourceMappingURL=whatsapp-inbound-presentation.js.map